import * as React from "react";
const SvgDisconnectedProfile = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-e894e669-7012-4d56-987a-6ef437f3871a", "data-name": "Warstwa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 7.75, style: {
  fill: "#de3c46",
  stroke: "#2f3232",
  strokeWidth: ".5px"
} }));
export default SvgDisconnectedProfile;
